import Tracker from '@shared/Tracker'

// Compares how long each insurance selection variant takes until its list is
// on screen, measured from when the route started rendering.
export const trackInsuranceListLoaded = (enteredAt: number, rowCount: number) =>
  Tracker.trackKaiaEvent(
    {
      event_name: 'c.lfcycl.insurance_list_loaded',
      action: 'load',
      object_type: 'insurance_list',
      screen_name: 'insurance_selection',
    },
    {
      duration_ms: Math.round(performance.now() - enteredAt),
      row_count: rowCount,
    },
  )
